import { app } from "./serviceLMS";
import { DELETE_BUNDLE, GET_BUNDLE_COURSES, GET_COURSES } from "./URLs";
import { GET_ENROLLMENT_SUMMARY } from "./URLs";

export const getAllBundles = async (
  page = 0,
  size = 10,
  active = true,
  sortBy = "bundleId",
  sortDir = "asc"
) => {
  try {
    const response = await app.get("course/api/client-api/bundles", {
      params: { page, size, active, sortBy, sortDir },
    });
    return response?.data?.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw new Error(error?.response?.data?.message);
  }
};

export const getAllBundlesPaged = async (
  page = 0,
  size = 10,
  active = true,
  sortBy = "bundleId",
  sortDir = "desc",
  search = ""
) => {
  try {
    const response = await app.get("course/api/client-api/bundles/paged", {
      params: { 
        page, 
        size, 
        active, 
        sortBy, 
        sortDir,
        ...(search ? { search } : {}), 
      },
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch bundles." };
    }
  } catch (error) {
    return {
      success: false,
      data: error?.response?.data?.message || "Error fetching bundles.",
    };
  }
};


export const getAllBundleCourses = async (bundleId, page = 0, size = 10, sortBy = 'createdAt', sortDir = 'asc', search = '', active = true) => {
    try {
        const params = new URLSearchParams({
            bundleId,
            page,
            size,
            sortBy,
            sortDir,
            active,
        });

        if (search) {
            params.append('search', search);
        }

        const response = await app.get(`${GET_BUNDLE_COURSES}?${params.toString()}`);
        console.log("Course DETAILS", response.data.data);
        return response.data.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message);
    }
};

export const CoursesToAdd = async (bundleId) => {

    try {
        const response = await app.get(`course/api/client-api/course-bundles/bundle/courses?bundleId=${bundleId}`)
        console.log("Course DETAILS", response.data.data);
        return response.data.data;
    } catch (error) {

        throw new Error(error?.response?.data?.message);
    }

};



export const addCourseToBundle = async (bundle) => {

    try {
        const response = await app.post('course/api/client-api/course-bundles/bundle/addCourse', bundle)
        console.log("Course DETAILS", response.data.data);
        return response.data;
    } catch (error) {

        throw new Error(error?.response?.data?.message);
    }

};


export const deleteCourseFromBundle = async (bundleId, courseId) => {
    try {
        const response = await app.delete(`user/api/client-api/admin/bundle/removecourse?bundleId=${bundleId}&courseId=${courseId}`)
        return response.data;
    } catch (error) {

        throw new Error(error?.response?.data?.message);
    }
}



export const updateBundle = async (bundle, id) => {

    try {
        const response = await app.patch(`course/api/client-api/bundles/${id}`, bundle)
        return response.data;
    } catch (error) {

        throw new Error(error?.response?.data?.message);
    }

};


export const getCourses = async () => {
  try {
    const response = await app.get(GET_COURSES);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch courses." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching courses." };
  }
};

export const createBundle = async (bundle) => {
    try {
        const bundleInDTO = {
            bundleName: bundle.bundleName,
            isActive: true
        };

        const bundleResponse = await app.post('course/api/client-api/bundles', bundleInDTO);
          if (bundleResponse?.data?.message?.includes("already exists")) {
               return bundleResponse;
            }


        const bundleCourseInDTO = {
            bundleId: bundleResponse.data.data.bundleId,
            courses: bundle.courses,

        };

        const courseResponse = await addCourseToBundle(bundleCourseInDTO);

        return courseResponse.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Server error while creating bundle");
    }
};



export const deleteBundle = async (bundleId) => {
    try {
        const response = await app.delete(DELETE_BUNDLE(bundleId));

        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || "Server error while deleting bundle"
        );
    }
};


export const bundlesOfGroup = async (groupId) => {
    try {
        const response = await app.get(`user/api/client-api/group/bundles?groupId=${groupId}`);
        return response.data.data;
    } catch (error) {
        throw new Error(error.response?.data?.message);
    }
}


export const getEnrollmentSummary = async (groupId, page = 0, size = 10, sortDir = "asc", type = null) => {
  try {
    const params = new URLSearchParams({ page, size, sortDir });
    if (type) params.append("typeFilter", type);

    const response = await app.get(`${GET_ENROLLMENT_SUMMARY(groupId)}?${params}`);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch enrollment summary." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching enrollment summary." };
  }
};